import {Injectable} from '@angular/core';
import {WeekdaysEnum} from "@shared/enums/weekdays.enum";
import {CampaignTypeEnum} from "@shared/enums/campaign-type.enum";
import {ProvidersEnum} from "@shared/enums/providers.enum";
import {UserCompanyTypeEnum} from "@shared/enums/user-company-type.enum";
import {DeliveryStatusEnum} from "@shared/enums/delivery-status.enum";
import {FilterItemModel} from '@shared/models/filter/filter-item.model';
import {CampaignStatusEnum} from "@shared/enums/campaign-status.enum";
import {PaymentCaseEnum} from "@shared/enums/payment-case.enum";
import {
  CampaignItemEvaluationTypeEnum
} from "@app/main/modules/report/components/campaign-report/abtest-campaign-analysis/model/campaign-Item-evaluation-type.enum";
import {
  CooperationSettlementRequestStatusEnum
} from "@app/main/modules/sales-cooperation/enums/cooperation-settlement-request-status.enum";
import {SendStatusEnum} from "@shared/enums/send-status.enum";
import {ActionNameEnum} from "@shared/enums/action-name.enum";
import {SendMessageEnum} from "@shared/enums/send-message.enum";
import {CodeReaderImportRequestStatus} from "@shared/enums/code-reader.enum";
import {WhoIsStatusEnum} from "@shared/enums/who-is-status.enum";
import {ContextEnum} from "@shared/enums/app.enum";
import {EnvironmentType} from "@shared/enums/developer.enum";
import {
  FastSendTemplateStatusEnum,
  FastSendTemplateTypeEnum
} from "@app/main/modules/fast-send/enums/fast-send-template-type.enum";
import {PrebuyLineFileType, SystemLineUsageEnum} from "@shared/enums/line.enum";
import {AccessSectionEnum} from "@shared/enums/access-section.enum";
import {SmartZoneSendState, TargetTime} from "@shared/enums/smart-zone.enum";
import {
  GenderFilterValue,
  MobileOsFilterValue,
  ResidenceFilterValue
} from "@app/main/modules/send-message/models/smart-zone-filter.model";
import {OperatorEnum} from "@shared/enums/operator.enum";
import {UtilityService} from "@shared/services/utility.service";
import {TextLengthEnum, TextStyleEnum, TextGoalEnum} from "@shared/enums/text-generation.enum";
import {FastSendTemplateCategory} from "@app/main/modules/fast-send/enums/fast-send-template-category.enum";
import {LineType} from "@shared/enums/line-type.enum";
import {BaleBotStatus} from "@shared/enums/bale-bot-status.enum";
import {MessengerProviderId} from "@shared/enums/messenger-provider-id.enum";
import {
  MessengerSendMessageSendingStatus
} from "@shared/enums/messenger-send-message-sending-status.enum";
import {MessengerSendPaymentMethod} from "@shared/enums/messenger-send-payment-method.enum";


@Injectable({
  providedIn: 'root'
})

export class SharedService {
  constructor(private _UtilityService: UtilityService) {
  }


  /*
  * setter functions
  */
  set tagList(value: FilterItemModel[]) {
    this.$tagList = value ?? [];
  }


  /*
  * getter functions
  */
  get tagList() {
    return this.$tagList;
  }


  get EditSVG() {
    return this.$EditSVG;
  }

  get QuestionSVG() {
    return this.$QuestionSVG;
  }

  get AddSVG() {
    return this.$AddSVG;
  }

  get EventSvg() {
    return this.$EventSVG;
  }

  get CheckmarkShield() {
    return this.$CheckmarkShield;
  }

  get DeleteSVG() {
    return this.$DeleteSVG;
  }

  get LogoLoginSVG() {
    return this.$LogoLoginSVG;
  }

  get loginLogMethodOptions() {
    return this.$loginLogMethodOptions;
  }

  get invoiceType() {
    return this.$invoiceType;
  }

  get ticketStatus() {
    return this.$ticketStatus;
  }

  get ticketDepartment() {
    return this.$ticketDepartment
  }

  get fastSendTemplateStatus() {
    return this.$fastSendTemplateStatus;
  }

  get fastSendTemplateType() {
    return this.$fastSendTemplateType;
  }
  get fastSendTemplateCategory() {
    return this.$fastSendTemplateCategory;
  }


  get campaignType() {
    return this.$campaignType;
  }

  get sendType() {
    return this.$sendSmsType;
  }

  get sendSmsState() {
    return this.$sendSmsState;
  }

  get codeReaderStatus() {
    return this.$codeReaderStatus;
  }


  get codeReaderImportStatus() {
    return this.$codeReaderImportStatus;
  }


  get campaignStatus() {
    return this.$campaignStatus;
  }

  get messengerBotDraftStatus() {
    return this.$messengerBotDraftStatus;
  }

  get messengerProvider() {
    return this.$messengerProvider;
  }

  get provider() {
    return this.$providerShownName;
  }

  get creditTransactionType() {
    return this.$creditTransactionType;
  }

  get paymentStatus() {
    return this.$paymentStatus;
  }

  get lineStatus() {
    return this.$lineStatus;
  }

  get lineEarnMethod() {
    return this.$lineEarnMethod;
  }

  get lineType() {
    return this.$lineType;
  }

  get lineTypeReady() {
    return this.$lineTypeReady;
  }

  get operator() {
    return this.$operator;
  }

  get operatorEng() {
    return this.$operatorEng;
  }

  get operatorImages() {
    return this.$operatorImages;
  }

  get operatorImagesDark() {
    return this.$operatorImagesDark;
  }

  get userCompanyType() {
    return this.$userCompanyType;
  }

  get deliveryStatus() {
    return this.$deliveryStatus;
  }

  get productType() {
    return this.$productType;
  }

  get whoIsStatus() {
    return this.$whoIsStatus;
  }

  get weekday() {
    return this.$weekday;
  }


  get persianRegex() {
    return this.$PersianRegex;
  }

  get completeInformation() {
    return this.$completeInformation;
  }

  get systemLineUsage() {
    return this.$systemLineUsage;
  }

  get sendStatus() {
    return this.$sendStatus;
  }

  get actionName() {
    return this.$actionName;
  }

  get context() {
    return this.$context;
  }

  get apiEnvironment() {
    return this.$ApiEnvironment;
  }

  get prebuyLineFileTypes() {
    return this.$prebuyLineFileTypes;
  }

  get prebuyLineTextTypes() {
    return this.$prebuyLineTextTypes;
  }

  get accessSection() {
    return this.$accessSection;
  }

  get targetTime() {
    return this.$targetTime;
  }

  get smartZoneSendState() {
    return this.$smartZoneSendState;
  }

  get smartZoneMobileOs() {
    return this.$smartZoneMobileOs;
  }

  get smartZoneGender() {
    return this.$smartZoneGender;
  }

  get smartZoneResidence() {
    return this.$smartZoneResidence;
  }

  get textLength() {
    return this.$textLength;
  }

  get textStyle() {
    return this.$textStyle;
  }

  get textGoal() {
    return this.$textGoal;
  }

  get messengerTransactionTypes() {
    return this.$messengerTransactionTypes;
  }

  get messengerSendMessageSendingStatuses() {
    return this.$messengerSendMessageSendingStatuses;
  }

  get messengerSendPaymentMethods() {
    return this.$messengerSendPaymentMethods;
  }

  private $PersianRegex = /^[\u0600-\u06FF\s]+$/;

  private $LogoLoginSVG = '../../../assets/images/Company-sms.ir.svg';
  private $DeleteSVG = '../../../assets/images/icons/modal/trash.svg';
  private $EditSVG = '../../../assets/images/icons/modal/edit.svg';
  private $QuestionSVG = '../../../assets/images/icons/modal/question.svg';
  private $AddSVG = '../../../assets/images/icons/modal/add.svg';
  private $EventSVG = '../../../assets/images/icons/modal/calender.svg';
  private $CheckmarkShield = '../../../assets/images/icons/modal/checkmark_shield.png';


  private $tagList: FilterItemModel[] = [];

  private $loginLogMethodOptions: FilterItemModel[] = [
    {name: 'نام کاربری و رمز عبور', value: 1},
    {name: 'موبایل', value: 2},
    {name: 'فراموشی رمز عبور', value: 3},
  ];

  private $invoiceType: FilterItemModel[] = [
    // {name: 'فاکتور خرید', value: 1},
    // {name: 'فاکتور بازگشتی', value: 2},
    {name: 'صورت حساب', value: 1},
    {name: 'صورت حساب برگشت', value: 2},
  ];

  private $ticketDepartment: FilterItemModel[] = [
    {name: 'پشتیبانی', value: 1},
    {name: 'فنی', value: 2},
    {name: 'مالی', value: 3},
  ];

  private $ticketStatus: FilterItemModel[] = [
    {name: 'فعال', value: 1},
    {name: 'پاسخ ادمین', value: 2},
    {name: 'پاسخ کاربر', value: 3},
    {name: 'در حال بررسی', value: 4},
    {name: 'تمام شده', value: 5},
    {name: 'در انتظار پیگیری', value: 6},

  ];

  private $fastSendTemplateStatus: FilterItemModel[] = [
    {name: 'در حال بررسی', value: FastSendTemplateStatusEnum.Pending},
    {name: 'تایید', value: FastSendTemplateStatusEnum.IsVerified},
    {name: 'عدم تایید', value: FastSendTemplateStatusEnum.UnVerified},
    {name: 'در حال بررسی', value: FastSendTemplateStatusEnum.EnamadChecking},
    {name: 'در حال بررسی', value: FastSendTemplateStatusEnum.XMAValidationChecking},
  ];

  private $fastSendTemplateType: FilterItemModel[] = [
    {name: 'پیشفرض', value: FastSendTemplateTypeEnum.default},
    {name: 'سفارشی', value: FastSendTemplateTypeEnum.custom},
  ];

  private $fastSendTemplateCategory: FilterItemModel[] = [
    { name: 'OTP', value: FastSendTemplateCategory.Otp },
    { name: 'اطلاع‌رسانی', value: FastSendTemplateCategory.Informational },
    { name: 'وضعیت سفارش', value: FastSendTemplateCategory.OrderStatus },
    { name: 'سایر', value: FastSendTemplateCategory.Other },
  ];


  private $campaignType: FilterItemModel[] = [
    {name: 'زمان بندی شده', value: CampaignTypeEnum.scheduled},
    {name: 'رویدادی', value: CampaignTypeEnum.event},
    {name: 'AB Test', value: CampaignTypeEnum.abTest},
  ];

  private $sendSmsType: FilterItemModel[] = [
    {name: 'ارسال سریع', value: SendMessageEnum.FastSend},
    {name: 'تست ارسال سریع', value: SendMessageEnum.FastSendTest},
    {name: 'ارسال ساده', value: SendMessageEnum.BulkSimpleSend},
    {name: 'ارسال هوشمند پارامتریک', value: SendMessageEnum.ParametricSmartSend},
    {name: 'ارسال هوشمند متناظر', value: SendMessageEnum.MultipleTextSmartSend},
    // {name: 'کمپین ساده', value: SendMessageEnum.SimpleCampaign},
    {name: 'کمپین دوره ای', value: SendMessageEnum.ScheduledCampaign},
    {name: 'کمپین رویدادی', value: SendMessageEnum.EventCampaign},
    {name: 'ارسال API', value: SendMessageEnum.ApiSend},
    {name: 'منشی پیامکی', value: SendMessageEnum.SmsSecretary},
    {name: 'انتقال پیامک', value: SendMessageEnum.SmsTransmission},
    {name: 'کمپین A-B Test', value: SendMessageEnum.ABTestCampaign},
    {name: 'بانک شماره', value: SendMessageEnum.MobileBank},
    {name: 'کدخوان', value: SendMessageEnum.CodeReader},
    {name: 'ارسال از دکل', value: SendMessageEnum.TowerSend},
    {name: 'ارسال سیستمی', value: SendMessageEnum.System},
  ];

  private $sendSmsState: FilterItemModel[] = [
    {name: 'آماده', value: 1},
    {name: 'در حال ارسال', value: 2},
    {name: 'بررسی صحت ارسال', value: 3},
    {name: 'پایان یافته', value: 4},
    {name: 'ناموفق', value: 5},
    {name: 'انتظار', value: 6},
    {name: 'رد شده', value: 7}
  ];

  private $providerShownName: FilterItemModel[] = [
    {name: 'مگفا', value: ProvidersEnum.Magfa},
    {name: 'رهیاب', value: ProvidersEnum.Rahyab},
    {name: 'ارمغان', value: ProvidersEnum.Armaqan},
    {name: 'آسانک', value: ProvidersEnum.Asanak},
    {name: 'آسیاتک', value: ProvidersEnum.AsiaTech},
    {name: 'نوآوران', value: ProvidersEnum.Noavaran},
    {name: 'جیرینگ', value: ProvidersEnum.Jiring},
    {name: 'شاتل', value: ProvidersEnum.Shatel},
    {name: 'آرین‌تل', value: ProvidersEnum.Ariantel},
    {name: 'پیشگام‌رایان', value: ProvidersEnum.PishgamRayan},
    {name: 'پیامک صوتی', value: ProvidersEnum.Workano},
  ];

  private $creditTransactionType: FilterItemModel[] = [
    {name: 'خرید اعتبار', value: 1},
    {name: 'ارسال پیامک', value: 2},
    {name: 'بازگشت اعتبار', value: 3},
    {name: 'انتقال از/به سامانه قدیم', value: 4},
    {name: 'اصلاح تعرفه', value: 5},
    {name: 'اصلاح اعتبار', value: 6},
    {name: 'هدیه', value: 7},
  ];

  private $paymentStatus: FilterItemModel[] = [
    {name: 'منتظر', value: 1},
    {name: 'موفق', value: 2},
    {name: 'ناموفق', value: 3},
    {name: 'تاخیر', value: 4},
  ];

  private $lineStatus: FilterItemModel[] = [
    {name: 'درحال بررسی', value: 1},
    {name: 'غیرفعال', value: 2},
    {name: 'فعال', value: 3},
  ];

  private $codeReaderStatus: FilterItemModel[] = [
    {name: 'صحیح', value: 1},
    {name: 'تکراری', value: 2},
    {name: 'نادرست', value: 3},
  ];

  private $codeReaderImportStatus: FilterItemModel[] = [
    {name: 'ایجاد شده', value: CodeReaderImportRequestStatus.Created},
    {name: 'در حال پردازش', value: CodeReaderImportRequestStatus.Processing},
    {name: 'انجام شده', value: CodeReaderImportRequestStatus.Completed},
    {name: 'خطا در اجرا', value: CodeReaderImportRequestStatus.ExecutionError},
    {name: 'محدودیت پلن', value: CodeReaderImportRequestStatus.PlanLimitation},
  ];


  private $campaignStatus: FilterItemModel[] = [
    {name: 'فعال', value: CampaignStatusEnum.Active},
    {name: 'غیر فعال', value: CampaignStatusEnum.Deactive},
    {name: 'تمام شده', value: CampaignStatusEnum.Finished},
  ];

  private $messengerBotDraftStatus: FilterItemModel[] = [
    {name: 'در انتظار بررسی', value: BaleBotStatus.PendingReviewByAdmin},
    {name: 'در حال ساخت در پیام رسان', value: BaleBotStatus.UnderCreationAtMessenger},
    {name: 'تایید شده', value: BaleBotStatus.Approved},
    {name: 'رد شده', value: BaleBotStatus.Rejected},
  ];

  private $messengerProvider: FilterItemModel[] = [
    {name: 'بله', value: MessengerProviderId.Bale},
    {name: 'پیشگام رایان', value: MessengerProviderId.PishgamRayan},
  ];

  private $lineEarnMethod: FilterItemModel[] = [
    {name: 'خط هدیه', value: 1},
    {name: 'خریداری شده', value: 2},
    {name: 'انتقالی', value: 3},
    {name: 'پلن', value: 4},
  ];

  private $lineType: FilterItemModel[] = [
    // {name: '----', value: 0},
    {name: 'تبلیغاتی', value: 1},
    {name: 'خدماتی', value: 2},
  ];

  private $lineTypeReady: FilterItemModel[] = [
    {name: 'خطوط خدماتی', value: LineType.Service},
    {name: 'خطوط تبلیغاتی', value: LineType.Advertising},
    {name: 'نامشخص', value: LineType.Unknown},
  ];

  private $operator: FilterItemModel[] = [
    {name: 'همراه اول', value: OperatorEnum.MCI},
    {name: 'ایرانسل', value: OperatorEnum.MTN},
    {name: 'رایتل', value: OperatorEnum.RighTel},
    {name: 'تالیا', value: OperatorEnum.Talya},
  ];

  private $operatorEng: FilterItemModel[] = [
    {name: 'MCI', value: OperatorEnum.MCI},
    {name: 'MTN', value: OperatorEnum.MTN},
    {name: 'RighTel', value: OperatorEnum.RighTel},
    {name: 'Talya', value: OperatorEnum.Talya},
  ];

  private $operatorImages: FilterItemModel[] = [
    {name: 'assets/images/mci.svg', value: OperatorEnum.MCI},
    {name: 'assets/images/irancell.svg', value: OperatorEnum.MTN},
    {name: 'assets/images/rightel.svg', value: OperatorEnum.RighTel},
    {name: '', value: OperatorEnum.Talya},
  ];

  private $operatorImagesDark: FilterItemModel[] = [
    {name: 'assets/images/mci-dark.svg', value: OperatorEnum.MCI},
    {name: 'assets/images/irancell.svg', value: OperatorEnum.MTN},
    {name: 'assets/images/rightel.svg', value: OperatorEnum.RighTel},
    {name: '', value: OperatorEnum.Talya},
  ];

  private $userCompanyType: FilterItemModel[] = [
    {name: 'سهامی خاص', value: UserCompanyTypeEnum.PrivateStock},
    {name: 'سهامی عام', value: UserCompanyTypeEnum.PublicStock},
    {name: 'مسئولیت محدود', value: UserCompanyTypeEnum.LimitedLiability},
    {name: 'تضامنی', value: UserCompanyTypeEnum.GeneralPartnership},
    {name: 'دولتی', value: UserCompanyTypeEnum.StateOwned},
    {name: 'وزارتخانه', value: UserCompanyTypeEnum.Ministry},
    {name: 'سفارتخانه', value: UserCompanyTypeEnum.Embassy},
    {name: 'مسجد', value: UserCompanyTypeEnum.Mosque},
    {name: 'مدرسه', value: UserCompanyTypeEnum.School},
    {name: 'NGO', value: UserCompanyTypeEnum.NGO},
    {name: 'موسسه', value: UserCompanyTypeEnum.Institute},
    {name: 'سایر', value: UserCompanyTypeEnum.Other},
  ];

  private $deliveryStatus: FilterItemModel[] = [
    {name: 'رسیده', value: DeliveryStatusEnum.Delivered},
    {name: 'نرسیده به گوشی', value: DeliveryStatusEnum.Undelivered},
    {name: 'رسیده به مخابرات', value: DeliveryStatusEnum.ReachedTheOperator},
    {name: 'نرسیده به مخابرات', value: DeliveryStatusEnum.NotReachedTheOperator},
    {name: 'رسیده به اپراتور', value: DeliveryStatusEnum.ReachedTheProvider},
    {name: 'ناموفق', value: DeliveryStatusEnum.Failed},
    {name: 'لیست سیاه', value: DeliveryStatusEnum.BlackList},
    {name: 'نامشخص', value: DeliveryStatusEnum.Unknown},
  ];

  private $weekday: FilterItemModel[] = [
    {name: 'شنبه', value: WeekdaysEnum.Saturday},
    {name: 'یکشنبه', value: WeekdaysEnum.Sunday},
    {name: 'دوشنبه', value: WeekdaysEnum.Monday},
    {name: 'سه شنبه', value: WeekdaysEnum.Tuesday},
    {name: 'چهارشنبه', value: WeekdaysEnum.Wednesday},
    {name: 'پنجشنبه', value: WeekdaysEnum.Thursday},
    {name: 'جمعه', value: WeekdaysEnum.Friday},
  ];

  private $productType: FilterItemModel[] = [
    {name: 'خط', value: PaymentCaseEnum.Line},
    {name: 'پیش فاکتور', value: PaymentCaseEnum.Proforma},
    {name: 'شارژ', value: PaymentCaseEnum.CustomCredit},
    {name: 'پکیج', value: PaymentCaseEnum.Packages},
    {name: 'پلن ها', value: PaymentCaseEnum.Plans},
    {name: 'ارسال از دکل', value: PaymentCaseEnum.Tower},
    {name: 'ارزش افزوده', value: PaymentCaseEnum.Official},
    {name: 'تعرفه اختصاصی', value: PaymentCaseEnum.DedicatedBasePrice},
    {name: 'ارسال از دکل', value: PaymentCaseEnum.SmartZoneSend},
    {name: 'ارسال در پیام‌رسان', value: PaymentCaseEnum.MessengerSend},
  ];

  private $campaignItemEvaluation: FilterItemModel[] = [
    {name: 'بازخورد خوبی نداشت', value: CampaignItemEvaluationTypeEnum.DidNotHaveGoodFeedBack},
    {name: 'آمار خاصی بدست نیاوردیم', value: CampaignItemEvaluationTypeEnum.NoStatistics},
    {name: 'نسبتا خوب بود', value: CampaignItemEvaluationTypeEnum.FairlyGood},
    {name: 'از همه تست‌ها بهتر بود', value: CampaignItemEvaluationTypeEnum.TheBestTest},
    {name: 'بالای 50%', value: CampaignItemEvaluationTypeEnum.MoreThan50},
    {name: 'بالای 75%', value: CampaignItemEvaluationTypeEnum.MoreThan75},
    {name: 'پایین 50%', value: CampaignItemEvaluationTypeEnum.LessThan50},
    {name: 'موفقیت‌آمیز بود', value: CampaignItemEvaluationTypeEnum.Successful},
    {name: 'با شکست روبه‌رو شد', value: CampaignItemEvaluationTypeEnum.Failed},
    {name: 'از همه تست‌ها بدتر بود', value: CampaignItemEvaluationTypeEnum.TheWorstTest},
  ];

  private $whoIsLineState: FilterItemModel[] = [
    {name: 'فعال', value: true},
    {name: 'غیرفعال', value: false},
  ];


  private $whoIsStatus: FilterItemModel[] = [
    {name: 'عدم ثبت اطلاعات', value: WhoIsStatusEnum.NoWhois},
    {name: 'تایید شده', value: WhoIsStatusEnum.Approved},
    {name: 'رد شده', value: WhoIsStatusEnum.Rejected},
    {name: 'در حال بررسی وضعیت', value: WhoIsStatusEnum.StatusCheck},
    {name: 'منقضی شده', value: WhoIsStatusEnum.Expired},
    {name: 'در انتظار استعلام', value: WhoIsStatusEnum.PendingInquiry},
  ];


  private $settlementState: FilterItemModel[] = [
    {name: 'ارسال درخواست', value: CooperationSettlementRequestStatusEnum.Pending},
    {name: 'درحال بررسی', value: CooperationSettlementRequestStatusEnum.InProgress},
    {name: 'انجام شده', value: CooperationSettlementRequestStatusEnum.Done},
    {name: 'رد شده', value: CooperationSettlementRequestStatusEnum.Rejected},
  ];

  private $completeInformation: FilterItemModel[] = [
    {name: 'FatherName', value: 1},
  ];

  private $systemLineUsage: FilterItemModel[] = [
    {name: 'هیچ‌کدام', value: SystemLineUsageEnum.None},
    {name: 'تأیید سیستم', value: SystemLineUsageEnum.SystemVerification},
    {name: 'اطلاع‌رسانی', value: SystemLineUsageEnum.Notification},
    {name: 'تبلیغات', value: SystemLineUsageEnum.Advertising},
    {name: 'ماژول', value: SystemLineUsageEnum.Module},
    {name: 'همکاری', value: SystemLineUsageEnum.Cooperation},
    {name: 'عملیات داخلی', value: SystemLineUsageEnum.InternalOperations},
    {name: 'گروه خط عمومی', value: SystemLineUsageEnum.PublicLineGroup},
    {name: 'پیامک سفید', value: SystemLineUsageEnum.PayamakSefid},
  ];

  private $sendStatus: FilterItemModel[] = [
    {name: 'درخواست شما با خطا مواجه شده‌است.', value: SendStatusEnum.InternalServerError},
    {name: 'عملیات با موفقیت انجام شد', value: SendStatusEnum.Success},
    {name: 'کلید وب سرویس نامعتبر است', value: SendStatusEnum.ApiKeyIsWrong},
    {name: 'کلید وب سرویس غیرفعال است', value: SendStatusEnum.ApiKeyIsInactive},
    {name: "کلید وب سرویس محدود به آی‌پی‌های تعریف شده می‌باشد.", value: SendStatusEnum.ApiKeyIsLimitedToIp},
    {name: "حساب کاربری غیرفعال است", value: SendStatusEnum.UserAccountIsDeactivated},
    {name: "حساب کاربری در حالت تعلیق قرار دارد", value: SendStatusEnum.UserAccountIsSuspended},
    {name: "به منظور استفاده از وب سرویس پلن خود را ارتقا دهید", value: SendStatusEnum.PlanItemAccessDenied},
    {name: "مقدار ارسالی پارامتر نادرست می‌باشد", value: SendStatusEnum.InvalidRequestModel},
    {name: "تعداد درخواست بیشتر از حد مجاز است", value: SendStatusEnum.RequestRateLimitExceeded},
    {name: "شماره خط نامعتبر میباشد", value: SendStatusEnum.LineNumberIsWrong},
    {name: "اعتبار کافی نمیباشد", value: SendStatusEnum.CreditNotEnough},
    {name: "درخواست شما دارای متن (های) خالی است", value: SendStatusEnum.NullOrEmptyMessageText},
    {name: "درخواست شما دارای موبایل (های) نادرست است", value: SendStatusEnum.MobileIsWrong},
    {name: "تعداد موبایل ها بیشتر از حد مجاز (100 عدد) میباشد", value: SendStatusEnum.TooManyMobileListCount},
    {name: "تعداد متن ها بیشتر از حد مجاز (100 عدد) میباشد", value: SendStatusEnum.TooManyMessageTextListCount},
    {name: "لیست موبایل ها خالی میباشد", value: SendStatusEnum.EmptyMobileList},
    {name: "لیست متن ها خالی میباشد", value: SendStatusEnum.EmptyMessageTextsList},
    {name: "زمان ارسال نامعتبر میباشد", value: SendStatusEnum.InvalidSendDateTime},
    {
      name: "تعداد شماره موبایل ها و تعداد متن ها برابر نیستند",
      value: SendStatusEnum.MobilesAndMessageTextsNotCompatible
    },
    {name: "با این شناسه ارسالی ثبت نشده است", value: SendStatusEnum.IdIsWrong},
    {name: "رکوردی برای حذف یافت نشد", value: SendStatusEnum.ScheduledMessagesNotFound},
    {name: "قالب یافت نشد", value: SendStatusEnum.TemplateNotFound},
    {
      name: "طول رشته مقدار پارامتر، بیش از حد مجاز (25 کاراکتر) میباشد",
      value: SendStatusEnum.LengthOfParameterValueIsLongerThanAllowed
    },
    {name: "شماره موبایل(ها) در لیست سیاه سامانه می‌باشند", value: SendStatusEnum.AllMobilesAreInBlackList},
    {
      name: "نام یک یا چند پارامتر مقداردهی نشده‌است. لطفا به بخش مستندات ارسال وریفای مراجعه فرمایید",
      value: SendStatusEnum.ParameterNameIsNullOrEmpty
    },
    {name: "متن ارسال شده مورد تایید نمی‌باشد", value: SendStatusEnum.InvalidFrequentMessageText},
    {name: "تعداد پیام ها بیشتر از حد مجاز میباشد", value: SendStatusEnum.MessageCountOutOfRange},
    {
      name: "به منظور استفاده از قالب‌ شخصی سازی شده پلن خود را ارتقا دهید",
      value: SendStatusEnum.CustomFastSendTemplatePlanLimitation
    },
    {
      name: "به منظور افزودن قالب بیشتر پلن خود را ارتقا دهید",
      value: SendStatusEnum.PlanAccessLimitationCountForTemplate
    },
    {
      name: "ویرایش قالب در حال بررسی امکان‌پذیر نیست",
      value: SendStatusEnum.TemplateModificationNotAllowed
    },
    {
      name: "خط ارسال‌کننده نیاز به فعال‌سازی دارد.",
      value: SendStatusEnum.SenderLineRequiresApproval
    },
    {
      name: "درحال حاضر، فقط امکان ارسال پیامک OTP وجود دارد و قالب شما OTP شناسایی نشده است!",
      value: SendStatusEnum.OnlyOtpSendIsAllowed
    },
    {
      name: "متن قالب باید حداقل شامل یک متغیر به شکل #PARAMETER# باشد",
      value: SendStatusEnum.TemplateMustHaveAtLeastOneParameter
    },
  ];

  private $actionName: FilterItemModel[] = [
    {name: "ارسال وریفای", value: ActionNameEnum.VerifySend},
    {name: "ارسال گروهی", value: ActionNameEnum.BulkSend},
    {name: "ارسال نظیر به نظیر", value: ActionNameEnum.PeerToPeerSend},
    {name: "ارسال از طریق URL", value: ActionNameEnum.UrlSend},
    {name: "حذف ارسال زمانبندی شده", value: ActionNameEnum.RemoveScheduledMessages},
    {name: "گزارش پیامک (دریافت وضعیت)", value: ActionNameEnum.GetSentMessage},
    {name: "گزارش مجموعه ارسال", value: ActionNameEnum.GetPack},
    {name: "گزارش مجموعه ارسال‌های روز", value: ActionNameEnum.GetLivePacks},
    {name: "گزارش ارسال‌های روز", value: ActionNameEnum.GetSendLiveReport},
    {name: "گزارش ارسال‌های آرشیو شده", value: ActionNameEnum.GetSendArchiveLiveReport},
    {name: "گزارش تازه‌ترین پیامک‌های دریافتی", value: ActionNameEnum.GetReceiveLatestMessages},
    {name: "گزارش پیامک‌های دریافتی روز", value: ActionNameEnum.GetReceiveLiveReport},
    {name: "گزارش پیامک‌های دریافتی آرشیو شده", value: ActionNameEnum.GetReceiveArchiveReport},
    {name: "دریافت لیست خطوط", value: ActionNameEnum.GetUserLines},
    {name: "دریافت مقدار اعتبار فعلی", value: ActionNameEnum.GetUserCredit},
  ];

  private $context: FilterItemModel[] = [
    {name: "پیامک سفید", value: ContextEnum.PayamakSefid},
    {name: "پنل کاربری", value: ContextEnum.UserPanel},
  ];

  private $ApiEnvironment: FilterItemModel[] = [
    {name: "عملیاتی - Production", value: EnvironmentType.Production},
    {name: "تست - Sandbox", value: EnvironmentType.Sandbox},
  ];

  private $prebuyLineFileTypes: FilterItemModel[] = [
    {name: 'جواز کسب', value: PrebuyLineFileType.TradeLicense},
    {name: 'شناسنامه', value: PrebuyLineFileType.IdentityCertificate},
    {name: 'تصویر روی کارت ملی', value: PrebuyLineFileType.NationalIDCardFront},
    {name: 'تصویر پشت کارت ملی', value: PrebuyLineFileType.NationalIDCardBack},
    {name: 'فرم تعهدنامه', value: PrebuyLineFileType.CommitmentAgreement},
    {name: 'سفته', value: PrebuyLineFileType.CollateralNote},
    {name: 'فرم تعهدنامه در سربرگ', value: PrebuyLineFileType.OfficialCommitmentLetter},
    {name: 'روزنامه رسمی', value: PrebuyLineFileType.OfficialRegistrationGazette},
    {name: 'آگهی تأسیس', value: PrebuyLineFileType.IncorporationNotice},
    {name: 'آخرین تغییرات', value: PrebuyLineFileType.LatestAmendments},
    {name: 'جواز صنفی', value: PrebuyLineFileType.BusinessPermit},
    {name: 'قبض تلفن', value: PrebuyLineFileType.TelephoneBill},
    {name: 'معرفی نامه', value: PrebuyLineFileType.LetterOfIntroduction},
  ];

  private $prebuyLineTextTypes: FilterItemModel[] = [
    {name: 'نوع فعالیت', value: PrebuyLineFileType.ActivityType},
    {name: 'نمونه متن', value: PrebuyLineFileType.SampleText},
    {name: 'جامعه هدف', value: PrebuyLineFileType.TargetAudience},
  ];

  private $accessSection: FilterItemModel[] = [
    {name: 'تعداد مخاطبان', value: AccessSectionEnum.Contacts},
    {name: 'گروه بندی مخاطبان', value: AccessSectionEnum.ContactGroups},
    {name: 'رویداد مخاطبان', value: AccessSectionEnum.ContactEvents},
    {name: 'ارسال انبوه', value: AccessSectionEnum.BulkSend},
    {name: 'ارسال در بله', value: AccessSectionEnum.MessengerSend },
    {name: 'ارسال به بانک شماره', value: AccessSectionEnum.MobileBankSend},
    {name: 'ارسال پارامتریک', value: AccessSectionEnum.ParametricSend},
    {name: 'ارسال متناظر', value: AccessSectionEnum.MultipleTextSend},
    {name: 'کمپین زمانبندی شده', value: AccessSectionEnum.ScheduledCampaign},
    {name: 'کمپین A/B', value: AccessSectionEnum.ABTestCampaign},
    {name: 'کمپین رویدادی', value: AccessSectionEnum.EventCampaign},
    {name: 'گزارش دریافتی ها', value: AccessSectionEnum.ReceivedMessagesReport},
    {name: 'پیش نویس', value: AccessSectionEnum.UserTemplate},
    {name: 'استعلام لیست سیاه', value: AccessSectionEnum.BlackListInquiryCount},
    {name: 'همکاری در فروش', value: AccessSectionEnum.SaleCooperation},
    {name: 'کلید واژه اختصاصی لیست سیاه', value: AccessSectionEnum.PersonalBlackListKeyword},
    {name: 'ارسال سریع', value: AccessSectionEnum.FastSend},
    {name: 'تعداد کلید API', value: AccessSectionEnum.ApiKey},
    {name: 'IP قابل ثبت در کلید API', value: AccessSectionEnum.IPLimitationOnApiKeys},
    {name: 'انتقال پیامک', value: AccessSectionEnum.SmsTransmission},
    {name: 'انتقال پیامک با URL (خودکار)', value: AccessSectionEnum.SmsTransmissionApiParameterless},
    {name: 'تعداد انتقال پیامک با URL (پارامتریک)', value: AccessSectionEnum.SmsTransmissionApiWithParameter},
    {name: 'انتقال پیامک با ایمیل (خودکار)', value: AccessSectionEnum.SmsTransmissionEmailParameterless},
    {name: 'تعداد انتقال پیامک با ایمیل (پارامتریک)', value: AccessSectionEnum.SmsTransmissionEmailWithParameter},
    {name: 'انتقال پیامک با موبایل (خودکار)', value: AccessSectionEnum.SmsTransmissionMobileParameterless},
    {name: 'تعداد انتقال پیامک با موبایل (پارامتریک)', value: AccessSectionEnum.SmsTransmissionMobileWithParameter},
    {name: 'منشی پیامکی (خودکار)', value: AccessSectionEnum.SmsSecretaryParameterless},
    {name: 'تعداد منشی پیامکی (پارامتریک)', value: AccessSectionEnum.SmsSecretaryWithParameter},
    {name: 'کدخوان', value: AccessSectionEnum.CodeReader},
    {name: 'تعداد پارامترهای کدخوان', value: AccessSectionEnum.CodeReaderParameters},
    {name: 'ارسال از دکل', value: AccessSectionEnum.SmartZoneSend},
    {name: 'وب سرویس', value: AccessSectionEnum.WebServices},
    {name: 'تعداد مخاطبان پیامک سفید', value: AccessSectionEnum.PayamakSefidContactsCount},
    {name: 'دستیار هوش مصنوعی ایکسما', value: AccessSectionEnum.XMAAI},
    {name: 'خرید اعتبار', value: AccessSectionEnum.BuyCredit},
    {name: 'خرید خط', value: AccessSectionEnum.BuyLine},
    {name: 'خرید پلن', value: AccessSectionEnum.BuyPlan},
    {name: 'خرید ارسال از دکل', value: AccessSectionEnum.BuySmartZoneSend},
    {name: 'منشی پیامکی', value: AccessSectionEnum.SmsSecretary}
    ];

  private $targetTime: FilterItemModel[] = [
    {name: 'گذشته', value: TargetTime.Past},
    {name: 'آینده', value: TargetTime.Future},
  ];

  private $smartZoneSendState: FilterItemModel[] = [
    {name: 'بررسی محدوده', value: SmartZoneSendState.CheckPolygon},
    {name: 'در حال پردازش', value: SmartZoneSendState.WaitingForGreyListCreation},
    {name: 'در حال آماده‌سازی', value: SmartZoneSendState.EnsureGreyListCreated},
    {name: 'آماده برای ایجاد ارسال', value: SmartZoneSendState.ReadyToCreateSend},
    {name: 'در حال گردآوری مخاطبان', value: SmartZoneSendState.Refreshing},
    {name: 'در انتظار متن پیامک', value: SmartZoneSendState.WaitingForMessageEntry},
    {name: 'در انتظار انتخاب مخاطبان', value: SmartZoneSendState.WaitingForRecipientSelection},
    {name: 'در انتظار بررسی', value: SmartZoneSendState.WaitingForAdminManualReview},
    {name: 'در انتظار پرداخت', value: SmartZoneSendState.WaitingForPayment},
    {name: 'بررسی فیش واریزی', value: SmartZoneSendState.WaitingForAdminManualPaymentReview},
    {name: 'پرداخت شده', value: SmartZoneSendState.Paid},
    {name: 'ارسال به اپراتور', value: SmartZoneSendState.SentToProvider},
    {name: 'پایان یافته', value: SmartZoneSendState.Finished},
    {name: 'رد شده', value: SmartZoneSendState.Rejected},
    {name: 'ناموفق', value: SmartZoneSendState.Failed},
    {name: 'منقضی شده', value: SmartZoneSendState.Expired},
    {name: 'در انتظار تأیید کاربر', value: SmartZoneSendState.WaitingForUserConfirmation},
  ];

  private $smartZoneMobileOs: FilterItemModel[] = [
    {name: 'اندروید', value: 'android' as MobileOsFilterValue},
    {name: 'iOS', value: 'ios' as MobileOsFilterValue},
    {name: 'سایر', value: 'other' as MobileOsFilterValue},
  ];

  private $smartZoneGender: FilterItemModel[] = [
    {name: 'مرد', value: 'male' as GenderFilterValue},
    {name: 'زن', value: 'female' as GenderFilterValue},
  ];

  private $smartZoneResidence: FilterItemModel[] = [
    {name: 'ساکن در منطقه', value: 'resident' as ResidenceFilterValue},
    {name: 'مهمان', value: 'guest' as ResidenceFilterValue},
  ];

  private $textLength: FilterItemModel[] = [
    {name: 'کوتاه', value: TextLengthEnum.Short},
    {name: 'متوسط', value: TextLengthEnum.Medium},
    {name: 'طولانی', value: TextLengthEnum.Long},
  ];

  private $textStyle: FilterItemModel[] = [
    {name: 'صمیمی', value: TextStyleEnum.Friendly},
    {name: 'رسمی', value: TextStyleEnum.Formal},
    {name: 'ساده', value: TextStyleEnum.Simple},
  ];

  private $textGoal: FilterItemModel[] = [
    {name: 'تبلیغاتی', value: TextGoalEnum.Promotional},
    {name: 'اطلاع رسانی', value: TextGoalEnum.Informative},
    {name: 'فراخوان به عمل (Call to Action)', value: TextGoalEnum.CallToAction},
  ];

  private $messengerTransactionTypes: FilterItemModel[] = [
    {name: 'شارژ اعتبار', value: 1},
    {name: 'مصرف برای ارسال', value: 2},
    {name: 'برگشت اعتبار', value: 3},
    {name: 'اصلاح اعتبار توسط ادمین', value: 4},
    {name: 'هدیه', value: 5},
  ];

  private $messengerSendMessageSendingStatuses: FilterItemModel[] = [
    {name: 'در انتظار ارسال', value: MessengerSendMessageSendingStatus.Pending},
    {name: 'موفق', value: MessengerSendMessageSendingStatus.Succeeded},
    {name: 'مسدودشده توسط ارائه‌دهنده', value: MessengerSendMessageSendingStatus.BlacklistedByProvider},
    {name: 'ناموفق', value: MessengerSendMessageSendingStatus.Failed},
  ];

  private $messengerSendPaymentMethods: FilterItemModel[] = [
    {name: 'آنلاین', value: MessengerSendPaymentMethod.Online},
    {name: 'دستی', value: MessengerSendPaymentMethod.Manual},
    {name: 'تسویه‌شده', value: MessengerSendPaymentMethod.Settled},
  ];
}
